/*
 _______________________________________________________
/ This code was generated by a tool.                    \
|                                                       |
| Changes to this file may cause incorrect behavior and |
\  will be lost if the code is regenerated.             /
 -------------------------------------------------------
       \   ,__,
        \  (oo)____
           (__)    )\
              ||--|| *
*/
enum NegotiationProceduresAliases {
  AUTOCOMPLETE_0 = 'autocomplete-0',
  AVATAR_0 = 'avatar-0',
  AVATAR_PROCEDURE = 'avatar-procedure',
  CARD_PROCEDURE = 'card-procedure',
  CHECKBOX_0 = 'checkbox-0',
  CONTEXTUAL_BAR_0 = 'contextual-bar-0',
  COUNTER_PROPOSAL_COLAPSE = 'counter-proposal-colapse',
  DECK_PROCEDURE = 'deck-procedure',
  FETCH_COUNT_OFFER = 'fetch-count-offer',
  FETCH_ORIGIN = 'fetch-origin',
  FETCH_PROCEDURES = 'fetch-procedures',
  FIELD_0 = 'field-0',
  FIELD_1 = 'field-1',
  FIELD_2 = 'field-2',
  FIELD_ANESTHETIC_SIZE = 'field-anestheticSize',
  FIELD_ANESTHETIST = 'field-anesthetist',
  FIELD_AUX_VALUES = 'field-aux-values',
  FIELD_AVATAR = 'field-avatar',
  FIELD_CODE = 'field-code',
  FIELD_CP_ANESTHETIC_SIZE = 'field-cp-anestheticSize',
  FIELD_CP_ANESTHETIC_SIZE_EDIT = 'field-cp-anestheticSize-edit',
  FIELD_CP_ANESTHETIST = 'field-cp-anesthetist',
  FIELD_CP_ANESTHETIST_EDIT = 'field-cp-anesthetist-edit',
  FIELD_CP_AUX_VALUES = 'field-cp-aux-values',
  FIELD_CP_AUX_VALUES_EDIT = 'field-cp-aux-values-edit',
  FIELD_CP_DOCTOR_VALUE = 'field-cp-doctor-value',
  FIELD_CP_DOCTOR_VALUE_EDIT = 'field-cp-doctor-value-edit',
  FIELD_CP_FILM_VALUE = 'field-cp-film-value',
  FIELD_CP_FILM_VALUE_EDIT = 'field-cp-film-value-edit',
  FIELD_CP_INCIDENCE = 'field-cp-incidence',
  FIELD_CP_INCIDENCE_EDIT = 'field-cp-incidence-edit',
  FIELD_CP_OPERATIONAL_COST = 'field-cpOperational-cost',
  FIELD_CP_PROCEDURE = 'field-cpProcedure',
  FIELD_CP_PROCEDURE_VALUE = 'field-cp-procedure-value',
  FIELD_CP_QTD_AUX = 'field-cp-qtd-aux',
  FIELD_CP_QTD_AUX_EDIT = 'field-cp-qtd-aux-edit',
  FIELD_CP_QTD_FILM = 'field-cp-qtd-film',
  FIELD_CP_QTD_FILM_EDIT = 'field-cp-qtd-film-edit',
  FIELD_DESCRIPTION = 'field-description',
  FIELD_DOCTOR_VALUE = 'field-doctor-value',
  FIELD_FILM_VALUE = 'field-film-value',
  FIELD_ID = 'field-id',
  FIELD_INCIDENCE = 'field-incidence',
  FIELD_OPERATIONAL_COST = 'field-operational-cost',
  FIELD_ORIGIN = 'field-origin',
  FIELD_PROCEDURE_VALUE = 'field-procedure-value',
  FIELD_QTD_AUX = 'field-qtd-aux',
  FIELD_QTD_FILM = 'field-qtd-film',
  FILTER_0 = 'filter-0',
  FILTERED_LIST_0 = 'filtered-list-0',
  FORM_COUNTER_OFFER = 'form-counter-offer',
  INPUT_0 = 'input-0',
  INPUT_1 = 'input-1',
  INPUT_2 = 'input-2',
  INPUT_3 = 'input-3',
  INPUT_4 = 'input-4',
  INPUT_5 = 'input-5',
  INPUT_6 = 'input-6',
  INPUT_7 = 'input-7',
  INPUT_8 = 'input-8',
  INPUT_9 = 'input-9',
  INPUT_CODE = 'input-code',
  INPUT_DESCRIPTION = 'input-description',
  LEGENDS_0 = 'legends-0',
  MAPPER_0 = 'mapper-0',
  MAPPER_AVATAR = 'mapper-avatar',
  MAPPER_ORIGIN = 'mapper-origin',
  MODAL_COUNTER_PROPOSAL = 'modal-counter-proposal',
  PANEL_0 = 'panel-0',
  PANEL_MODAL_COUNTER_OFFER = 'panel-modal-counter-offer',
  PROPOSAL_COLAPSE = 'proposal-colapse',
  TEXT_0 = 'text-0',
  TEXT_1 = 'text-1',
  TEXT_2 = 'text-2',
  TEXT_3 = 'text-3',
  TEXT_4 = 'text-4',
  TEXT_5 = 'text-5',
  TEXT_6 = 'text-6',
  TEXT_7 = 'text-7',
  TEXT_8 = 'text-8',
  TEXT_ANESTHETIST = 'text-anesthetist',
  TEXT_CP_0 = 'text-cp-0',
  TEXT_CP_1 = 'text-cp-1',
  TEXT_CP_2 = 'text-cp-2',
  TEXT_CP_3 = 'text-cp-3',
  TEXT_CP_4 = 'text-cp-4',
  TEXT_CP_5 = 'text-cp-5',
  TEXT_CP_6 = 'text-cp-6',
  TEXT_CP_7 = 'text-cp-7',
  TEXT_CP_8 = 'text-cp-8',
  TEXT_CP_ANESTHETIST = 'text-cp-anesthetist',
  TEXT_ID = 'text-id',
  TEXT_ORIGIN = 'text-origin',
}
export { NegotiationProceduresAliases };
